<template>
  <div
    class="UploadFilesLeft"
    @drop.stop
  >
    <div class="panel">
      <div v-if="documentKinds.length > 0">
        <div class="input-title mb-2">
          {{ $t('main.documents.wording.input-select-title') }}
        </div>
        <SelectInput
          :value="documentKind"
          :default="documentKind"
          :options="documentKinds"
          item-text="label"
          item-value="code"
          @input="$emit('update:documentKind', $event)"
        />
      </div>
      <div
        v-if="!isReadOnly"
        class="input-title mb-2"
      >
        {{ $t('main.documents.wording.input-title') }}
      </div>
      <v-file-input
        v-if="!isReadOnly"
        v-cloak
        v-model="selectedFiles"
        :placeholder="$t('main.documents.wording.file-input-placeholder')"
        :hint="fileInputHint"
        :rules="inputFileRules"
        :background-color="fileInputBackground"
        dense
        persistent-hint
        accept="image/png, image/jpeg, .pdf"
        filled
        outlined
        multiple
        prepend-icon=""
        prepend-inner-icon="mdi-file-document"
        class="UploadFilesLeft_fileInput mb-4"
        @change="onUploadFile"
      />
      <p
        v-if="isInvalid"
        class="UploadFilesLeft_status--invalid"
      >
        {{ $t('main.documents.wording.invalid') }}
      </p>
      <p
        v-if="isReadOnly"
        class="UploadFilesLeft_status--invalid"
      >
        {{ $t('main.documents.wording.is-read-only') }}
      </p>
      <Files
        :files="files"
        :isReadOnly="isReadOnly"
        @removeFile="$emit('removeFile', $event)"
      />
    </div>
  </div>
</template>

<script>
  import SelectInput from '@/components/ui/inputs/SelectInput'

  import Files from '@/components/common/Files/Files'

  import { DOCUMENT_STATUSES } from '@/components/ui/inputs/FileInput.const'
  import { getListdocumentKind } from '@/components/ui/common/UploadFiles/UploadFilesLeft.utils'
  import { random } from '@/utils/common.utils'

  export default {
    components: {
      SelectInput,
      Files,
    },
    props: {
      document: {
        type: String,
        default: '',
      },
      pages: {
        type: Array,
        default: () => [],
      },
      files: {
        type: Array,
        required: true,
      },
      documentKind: {
        type: String,
        default: '',
      },
      documentStatus: {
        type: String,
        required: true,
      },
      isInvalid: {
        type: Boolean,
        required: true,
      },
      maxSizeLabel: {
        type: String,
        default: '6 Mo',
      },
      maxSizeValue: {
        type: Number,
        default: 6_291_456,
      },
      fileInputBackground: {
        type: String,
        default: '#0000',
      },
      isOpened: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      const documentKinds = this.documentKind === '' ? getListdocumentKind(this.$t.bind(this)) : []

      return {
        documentKinds,
        uploadedFiles: [],
        DOCUMENT_STATUSES,
        selectedFiles: null,
      }
    },
    computed: {
      isReadOnly() {
        return this.documentStatus === DOCUMENT_STATUSES.sent_to_unicia
      },
      fileInputHint() {
        return this.$t('main.documents.wording.hint-with-size', { maxSize: this.maxSizeLabel, })
      },
      inputFileRules() {
        return [
          (uploadedFiles) => {
            return (
              !uploadedFiles ||
              uploadedFiles.length === 0 ||
              uploadedFiles.some((file) => file.size < this.maxSizeValue) ||
              this.$t('main.enums.error.file_size_warning', { maxSize: this.maxSizeLabel, })
            )
          },
        ]
      },
    },
    watch: {
      isOpened: function() {
        if (this.isOpened) {
          this.selectedFiles = null
        }
      },
    },
    methods: {
      onUploadFile(uploadedFiles) {
        const files = uploadedFiles.map((uploadedFile) => {
          const id = random('tmp-file-')
          Object.assign(uploadedFile, { id, })

          return uploadedFile
        })
        this.$emit('appendFiles', files)
      },
    },
  }
</script>

<style scoped lang="scss">
$label-invalid: $color_ea3b38;

.UploadFilesLeft {
  &_status {
    &--invalid {
      color: $label-invalid;
    }
  }
}
</style>
